import classNames from 'classnames';
import React from 'react';
import { DockPosition } from '@instinet-analytics/semantic-ui-components';
import { DockPositionEditor } from '@instinet-analytics/semantic-ui-components';
import { useCorporateActionsConfigSlice } from 'widgets/corpActions/widget/store/config/configSlice';

export function CorporateActionsSettings() {
    const { config, dispatchConfigChanged } = useCorporateActionsConfigSlice();

    const onDockPositionChanged = (nextPos?: DockPosition) => {
        dispatchConfigChanged({ dockPosition: nextPos });
    };

    return (
        <div className={classNames('CorporateActionsSettings')}>
            <div className="group">
                <div>
                    <div>Details Panel Position:</div>
                    <DockPositionEditor
                        position={config.dockPosition ?? 'Bottom'}
                        onChange={onDockPositionChanged}
                    />
                </div>
            </div>
        </div>
    );
}
